/**
 * Redux list slices: apply payload when the action includes one; otherwise keep the prior list.
 * GET handlers should dispatch receiveAction([]) on 404/400 so "no data yet" is not undefined.
 */

export const EMPTY_LIST = [];

export function mergeListReceiveState(actionValue, previousValue) {
  if (actionValue !== undefined) {
    return Array.isArray(actionValue) ? actionValue : EMPTY_LIST;
  }
  return previousValue;
}
